import { Box, Text, TextButton } from '@wix/design-system';
import { Refresh } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { BngDomainSuggestionsDataHooks } from './dataHooks';
const BngDomainSuggestionsError = _ref => {
  let onRetry = _ref.onRetry;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    verticalAlign: isMobile ? 'top' : 'middle',
    textAlign: "center",
    gap: isMobile ? 'SP1' : 'SP2',
    width: "100%",
    minHeight: isMobile ? '106px' : '239px',
    padding: isMobile ? '20px 0 0' : 'SP4',
    borderRadius: isMobile ? undefined : '12px',
    border: isMobile ? undefined : '1px solid var(--wds-color-black-600)',
    boxSizing: "border-box",
    dataHook: BngDomainSuggestionsDataHooks.domainSuggestionsError
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, t('domain_search_gate.bng_results.error.suggestions_card.title')), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, t('domain_search_gate.bng_results.error.suggestions_card.description')), /*#__PURE__*/React.createElement(Box, {
    marginTop: isMobile ? '14px' : undefined
  }, /*#__PURE__*/React.createElement(TextButton, {
    prefixIcon: /*#__PURE__*/React.createElement(Refresh, null),
    onClick: onRetry
  }, t('domain_search_gate.bng_results.suggestions.refresh.cta'))));
};
export default BngDomainSuggestionsError;
//# sourceMappingURL=BngDomainSuggestionsError.js.map